<div class="body">
    <button mat-button mat-icon-button class="options" matTooltip="Weitere Optionen" [matMenuTriggerFor]="options">
        <mat-icon class="icon">menu</mat-icon>
    </button>
    <div class="label">
        <span class="highlighted">Wista</span> Produktshop
    </div>
    <div class="spacer"></div>
    <span class="cart-nav" (click)="openShoppingCartOverview()">Warenkorb</span>
    <span *ngIf="hasCart; else noCart" class="counter">
        {{cart.products.length}}
    </span>
    <button *ngIf="hasCart" mat-button mat-icon-button [disabled]="cart.products.length < 1" class="order" matTooltip="Bestellung abschließen" (click)="confirmOrder()">
        <mat-icon class="icon">done</mat-icon>
    </button>
</div>
<ng-template #noCart>
    <span class="counter">
        0
    </span>
</ng-template>

<mat-menu #options="matMenu">
    <div class="menu-section-header">Allgemein</div>
    <button mat-menu-item class="dropdown-item" disabled>
        <mat-icon class="dropdown-icon">search</mat-icon>
        <span>Bestehenden Warenkorb suchen</span>
    </button>
    <button mat-menu-item class="dropdown-item" disabled>
        <mat-icon class="dropdown-icon">edit</mat-icon>
        <span>Metadaten des Warenkorbs bearbeiten</span>
    </button>
    <button mat-menu-item class="dropdown-item" disabled>
        <mat-icon class="dropdown-icon">save</mat-icon>
        <span>Diesen Warenkorb speichern</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <div class="menu-section-header">Warenkorb zu</div>
    <button mat-menu-item class="dropdown-item" (click)="selectOffer()">
        <span class="dropdown-placeholder"></span>
        <span>... Angebotsartikeln buchen</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="selectIssue()">
        <span class="dropdown-placeholder"></span>
        <span>... Vorgangsartikeln buchen</span>
    </button>
    <button mat-menu-item class="dropdown-item" (click)="selectContract()">
        <span class="dropdown-placeholder"></span>
        <span>... Vertragsartikeln buchen</span>
    </button>
    <mat-divider class="divider"></mat-divider>
    <div class="menu-section-header">Sonstig</div>
    <button mat-menu-item class="dropdown-item" routerLink="/home" routerLinkActive="active">
        <mat-icon class="dropdown-icon">home</mat-icon>
        <span>Interne Startseite</span>
    </button>
</mat-menu>